/**
 * 
 * クロス商品設定画面の値を管理するクラス
 *
 * @export KYMW4802Model
 * @class KYMW4802Model
 */
export class KYMW4802Model {
  /**  媒体区分 */
  public mediumType: string = <string>'';
  /**  媒体名 */
  public mediumName: string = <string>'';
  /**  企画回 */
  public catalogId: string = <string>'';
  /**  受注コード */
  public orderCode: string = <string>'';
  /**  Pコード */
  public pcode: string = <string>'';
  /**  商品名 */
  public guideGoodsName: string = <string>'';
  /**  規格名 */
  public guidsStandardName: string = <string>'';
  /** 画面表示用のクロス商品リスト */
  public crossGoodsList: Array<any> = [];
  /** クロス商品マップ */
  public crossGoodsMap = new Object();
  /** 表示要素数用リスト 掲載順Xを[ngForOf]で作成するために必要 */
  public displayList: Array<any> = [];
  /** 掲載順要素数リスト */
  public displayOrderLength = 0;

  /**
   * クロス商品一覧のデータ取得
   */
  public setBuyerCrossGoodsData(serverData: any): void {
    this.crossGoodsList = serverData;

    // グリッド表示用にマップで保持しリストの長さを揃える
    this.crossGoodsMap = new Object();
    this.displayList = [];
    this.displayOrderLength = 0;
    for (const e of this.crossGoodsList) {
      this.crossGoodsMap[e.DelivCatalogId] = e.CrossGoodsSetList;
      if (this.displayOrderLength < e.CrossGoodsSetList.length) {
        this.displayOrderLength = e.CrossGoodsSetList.length;
      }
    }
    for (const key of Object.keys(this.crossGoodsMap)) {
      const len = this.crossGoodsMap[key].length
      if (len < this.displayOrderLength) {
        const missing = this.displayOrderLength - len;
        for (let i = 0; i < missing; i++) {
          // 商品数が最大値に満たないクロス設定に関しては、設定がない掲載順の商品情報をすべて「-」で表示する。
          this.crossGoodsMap[key].push({
            PCode: '-',
            GuideGoodsName: '-',
            GuideStandardName: '-',
            ChildKomaSettings: '-'
          })
        }
      }
    }
    for (let i = 0; i < this.displayOrderLength; i++) {
      this.displayList.push({});
    }
  }

  /**
   * 媒体の表示内容を取得する
   *
   * @returns {string} 「媒体区分:媒体名」の文字列
   * @memberof KYMW4802Model
   */
  get mediumContent(): string {
    return this.mediumType + ":" + this.mediumName;
  }
}
